<div mat-dialog-content style="width: 500px">
  <h5 class="title text-center">CANCELAR OFERTA AUTOMÁTICA</h5>
  <div class="col-12 mt-2 mb-2">
    <p class="text-center">Ao cancelar a oferta automática, sua última oferta válida permanecerá ativa. No entanto, não
      haverá novas ofertas automáticos caso sua oferta seja superado.</p>


    <button class="btn btn-primary btn-rounded btn-block" (click)="onClickConfirm()">
      <span>
        CONFIRMAR
      </span>
    </button>
    <button class="btn btn-transparent btn-rounded btn-block" (click)="onNoClick()">CANCELAR</button>
  </div>
</div>